import { Dayjs } from "dayjs";
import {
  Controller,
  FieldValues,
  FieldPath,
  useFormContext,
} from "react-hook-form";
import { getErrorMessage } from "utils";

import TimePicker from "./TimePicker";
import { TimePickerHookFormProps } from "./TimePicker.types";

const TimePickerHookForm = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  defaultValue,
  rules,
  shouldUnregister,
  setPropsWithFormState,
  ...innerProps
}: TimePickerHookFormProps<TFieldValues, TName>) => {
  const { control } = useFormContext<TFieldValues>();
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      control={control}
      render={(formState) => {
        const {
          field: { disabled, ref, onChange, ...innerField },
          formState: { errors },
        } = formState;
        const error = getErrorMessage(errors, name);
        const errorMsg = error?.message;
        const helperText =
          typeof errorMsg === "string" ? errorMsg : innerProps?.helperText;
        return (
          <TimePicker
            {...innerProps}
            {...innerField}
            inputRef={ref}
            error={!!error}
            helperText={helperText}
            disabled={
              typeof disabled === "boolean" ? disabled : innerProps.disabled
            }
            onChange={onChange as (event: Dayjs | null) => void}
            {...(setPropsWithFormState?.(formState) ?? {})}
          />
        );
      }}
    />
  );
};

export default TimePickerHookForm;
